var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:notification-3-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4473 17.2109H22.4473V19.2109H2.44727V17.2109H4.44727V10.2109C4.44727 8.08921 5.29012 6.05437 6.79041 4.55408C8.2907 3.05379 10.3255 2.21094 12.4473 2.21094C14.569 2.21094 16.6038 3.05379 18.1041 4.55408C19.6044 6.05437 20.4473 8.08921 20.4473 10.2109V17.2109ZM9.44727 21.2109H15.4473V23.2109H9.44727V21.2109Z",
    fill: "#5E5E5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.cfa5a3c9a5859fd66a159b1a42186d55.svg";
export { ForwardRef as ReactComponent };